import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import i18n from '@i18n';
import {
  Table,
  withLayout,
  TableBottom,
  Section,
  useFirstRender,
} from '@casanova/casanova-common';
import { columns } from './columns';

function VehicleTransfers({
  match,
  vehicleTransfers,
  fetchVehicleTransfers,
  setPageVehicleTransfers,
  vehicleDetails = {},
  onlyFetchParams = true,
}) {
  const { params = {}, results = {} } = vehicleTransfers;

  const isFirstRender = useFirstRender();

  const vehicleUuid = useMemo(() => match.params.id, [match.params.id]);

  useEffect(() => {
    if (onlyFetchParams ? !isFirstRender : true) {
      fetchVehicleTransfers({
        params,
        plateNumber: vehicleDetails.plateNumber,
        serialNumber: vehicleDetails.serialNumber,
        uuid: vehicleUuid,
      });
    }
  }, [vehicleUuid, params, onlyFetchParams]);

  return (
    <Section title={i18n('VEHICLES__SECTIONS__VEHICLE_TRANSFERS__TITLE')}>
      <Table
        emptyMessage={i18n('ERROR__COMMONS__NOT_FOUND')}
        dataList={results.list}
        columns={columns}
      />
      <TableBottom
        search={vehicleTransfers}
        onChange={setPageVehicleTransfers}
        showButton={false}
      />
    </Section>
  );
}

VehicleTransfers.propTypes = {
  onlyFetchParams: PropTypes.bool,
};

export default withLayout(VehicleTransfers, { withLoader: false });
